import * as React from 'react';
import type * as Immutable from 'immutable';

import { singleton } from 'logic/singleton';
import type FieldTypeMapping from 'views/logic/fieldtypes/FieldTypeMapping';

const DataLakeFieldsContext = React.createContext<Immutable.List<FieldTypeMapping>>(undefined);

export default singleton('contexts.DataLakeFields', () => DataLakeFieldsContext);
